import React from 'react';
import PropTypes from 'prop-types';
const Icon = ({ fill, size, background, ...props }) => {
    return (
        <svg height={size} viewBox="0 0 60 48" width={size} stroke="currentColor" fill="currentColor" strokeWidth="0"  {...props}>
            <path d="M51.4,25.7c0.5-0.5,1.1-1.5,1.1-3.6c0-1.1-0.4-2-1.1-2.7c-1.3-1.3-3.4-1.3-3.5-1.3h-8.4
		c0.4-3.3,1.4-12.9-1.9-15.7c-0.7-0.6-2-1.2-3.9-0.6c-3.1,1-3.1,3.7-3.1,6.5c0,0.8,0,1.7-0.1,2.7c-0.2,2.6-2.8,6-7.1,7.1
		c-0.7,0.2-1.8,0.5-2.9,0.9c-0.3-1.2-1.4-2-2.7-2c-0.2,0-0.5,0-0.7,0.1l-4.5,1.1c-1.7,0.4-3.1,2.1-3.1,3.9v17.4
		c0,1.8,1.4,3.5,3.1,3.9l4.6,1.1c0.2,0.1,0.5,0.1,0.7,0.1c1.4,0,2.5-1,2.7-2.3c4.6,2.7,10.6,4.2,16.9,4.2c4.7,0,6.3-0.3,6.3-0.4
		c2.4-0.5,4.4-2.5,4.6-4.4l0.3-2.8c0.1,0,0.2-0.1,0.3-0.2c1.2-1.1,2.9-3.7,1.6-6.4c0.1,0,0.1-0.1,0.1-0.1
		C51.5,30.9,52.7,28.3,51.4,25.7z M18.8,41.5c0,0.8-0.6,1.2-1.3,1.1l-4.6-1.1c-0.9-0.2-1.7-1.2-1.7-2.2V22c0-1,0.8-2,1.7-2.2
		l4.5-1.1c0.1,0,0.2,0,0.3,0c0.6,0,1,0.4,1,1.1V41.5z M47.9,37h-1.8c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h0.7l-0.2,2.6
		c-0.1,1.2-1.6,2.5-3.2,2.9c0,0-1.5,0.3-5.9,0.3C31,44.5,25,42.9,20.6,40V20.8c1.1-0.4,2.2-0.7,3.2-1c5.1-1.3,8.2-5.5,8.4-8.7
		c0.1-1,0.1-1.9,0.1-2.8c0-2.9,0.1-4.3,1.9-4.9c1.2-0.4,1.9-0.1,2.2,0.2c2.6,2.2,1.8,11.7,1.2,15.1c0,0,0,0,0,0.1c0,0,0,0,0,0.1
		c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1
		c0,0,0,0,0.1,0.1c0,0,0,0,0.1,0.1c0,0,0,0,0.1,0.1c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0
		c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0h9.4c0,0,1.4,0,2.2,0.8c0.4,0.4,0.5,0.8,0.5,1.4c0,1.5-0.3,2.1-0.5,2.3h-2c-0.5,0-0.9,0.4-0.9,0.9
		c0,0.5,0.4,0.9,0.9,0.9h1.4c1.3,1.9,0.3,3.8-0.1,4.5h-2.3c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h1.3
		C50.1,34.3,48.6,36.3,47.9,37z" />
        </svg>
    );
}

Icon.propTypes = {
    fill: PropTypes.string,
    size: PropTypes.string,
    background: PropTypes.string,
    className: PropTypes.any,
    style: PropTypes.any,
};

Icon.defaultProps = {
    fill: '#000',
    size: null,
    background: 'none',
    style: null,
    className: null
};

export default React.memo(Icon);
